import { useState, useEffect, useRef } from "react";
import { FaRobot, FaStopCircle } from "react-icons/fa";
import { BsSend } from "react-icons/bs";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosCloseCircle, IoIosArrowBack } from "react-icons/io";
import WelcomeScreen from "./WelcomeScreen";
import { toast } from 'react-toastify';                           
import "./chatbot.css";

const ChatBot = () => {
  const [messages, setMessages] = useState([
    { type: "bot", text: "Hello! How can I help you today?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [tracRes, setTracRes] = useState(false);
  const [prePrompt, setPrePrompt] = useState(true);
  const [showWelcome, setShowWelcome] = useState(true);
  const[date, setDate] = useState()

  const chatEndRef = useRef(null);
  const typingTimeout = useRef(null);
  const fullResponseRef = useRef("");



  useEffect(()=>{
   const today = new Date();
   let date = getFormattedDate(today)
   setDate(date)
// console.log(getFormattedDate(today)); 

  }, [])
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    const hasSeenWelcome = localStorage.getItem("hasSeenWelcome");
    if (!hasSeenWelcome) {
      setShowWelcome(true);
      localStorage.setItem("hasSeenWelcome", "true");
    } else {
      setShowWelcome(false);
    }
  }, []);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const typeResponse = (text) => {
    fullResponseRef.current = text;
    let index = 0;
    let currentText = "";

    const type = () => {
      if (index < text.length) {
        currentText += text[index++];
        setMessages((prev) => {
          const updated = [...prev];
          updated[updated.length - 1].text = currentText;
          return updated;
        });
        scrollToBottom();
        typingTimeout.current = setTimeout(type, 20);
      } else {
        setTracRes(false);
      }
    };

    type();
  };

  const stopTyping = () => {
    if (typingTimeout.current) {
      clearTimeout(typingTimeout.current);
      typingTimeout.current = null;
    }
    setMessages((prev) => [
      ...prev.slice(0, -1),
      { type: "bot", text: fullResponseRef.current },
    ]);
    setTracRes(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    await sendMessage(input.trim());
    setInput("");
  };

 const sendMessage = async (text) => {
  const userMessage = { type: "user", text };
  setMessages((prev) => [...prev, userMessage]);
  setLoading(true);
  setTracRes(true);
  setPrePrompt(false);

  setMessages((prev) => [...prev, { type: "bot", text: "Typing..." }]);

  try {
    let userEmail = localStorage.getItem('user');
    userEmail = JSON.parse(userEmail);
    userEmail = userEmail?.email;

    if (!userEmail) return;

    
    let data = await chatHistore();  
    if (data && Array.isArray(data)) {
      setChatHistory(data);
      
    } else {
      
      setChatHistory((prev) => [...prev, text]);
     
    }

    
    const response = await axios.post(
      "https://bl-query-agent-187791816934.asia-south1.run.app/execute_prompt/",
      { prompt_string: text, email: userEmail },
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

   let resultArray = response?.data?.result || [];
let errorRes = response?.data?.error;

if (Array.isArray(resultArray) && resultArray.length > 0) {
} else if (errorRes) {
  

   errorRes = response?.data?.result
    console.log("Error:", errorRes);
} else {
   toast.error(" Failed: No result found.");
}


    const replyText = errorRes
      ? errorRes
      : resultArray
          .map((item) =>
            Object.entries(item)
              .map(([key, value]) => `${key}: ${value}`)
              .join("\n")
          )
          .join("\n\n") || "Sorry, I didn't understand that.";

    typeResponse(replyText);

  } catch (error) {
    setMessages((prev) => {
      const updated = [...prev];
      updated[updated.length - 1] = {
        type: "bot",
        text: "Oops! Something went wrong.",
      };
      return updated;
    });
    setTracRes(false);
  }

  setLoading(false);
};



const chatHistore = async () => {
  try {
    let userEmail = localStorage.getItem('user');
    userEmail = JSON.parse(userEmail);
    userEmail = userEmail?.email;

    if (!userEmail) {
      
      return null;
    }

    const response = await axios.post(
      "https://bl-query-agent-187791816934.asia-south1.run.app/session_prompts/",
      { email:userEmail},
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    let data = response?.data?.result?.user_prompts || null;
    if(data){
      return data
    }
    else{
      return null
    }

    

  } catch (error) {
    console.log("chatHistore error:", error.message);
    return null;
  }
};



  const handleQuickReply = async (reply) => {
    await sendMessage(reply);
  };

  const handleBackClick = () => {
    setMessages([{ type: "bot", text: "Hello! How can I help you today?" }]);
    setInput("");
    setLoading(false);
    setTracRes(false);
    setPrePrompt(true);
    setIsOpen(false);
    setShowWelcome(true); // return to welcome screen
  };

  const handleCloseChat = () => {
    setIsOpen(false);
    setShowWelcome(false); // hide welcome and chat
  };

  const handleHelpClick = () => {
    setIsOpen(true);
    setShowWelcome(false);
    setPrePrompt(false);
    setMessages([{ type: "bot", text: "Hi there! I’m here to help you." }]);
  };
function getFormattedDate(date) {
  const day = date.getDate();
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return `${getOrdinal(day)} ${month} ${year}`;
}



  const quickReplies = [
  
    "total learners in SRM",
    "total number of learners present today",
    "total number of learners present yesterday",
    "Show me number of learners" ,
      "Show me number of labs",
      `show me the percentage of learners present on ${date} `
  ];

  const filteredHistory = input
    ? chatHistory
        .filter(
          (msg, i, self) =>
            msg.toLowerCase().includes(input.toLowerCase()) &&
            self.indexOf(msg) === i
        )
        .slice(-5)
    : [];

  return (
    <>
      {/* Welcome Screen */}
      <AnimatePresence>
        {showWelcome && (
          <WelcomeScreen
            onStartChat={() => {
              setIsOpen(true);
              setShowWelcome(false);
            }}
            onHelpClick={handleHelpClick}
            onClose={handleCloseChat}
          />
        )}
      </AnimatePresence>

      {/* Chat Window */}
      <AnimatePresence>
        {isOpen && !showWelcome && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.3 }}
            className="fixed top-[70px] right-4 sm:right-6 w-[90vw] sm:w-[400px] h-[80vh] sm:h-[630px] z-50 bg-white shadow-2xl  border border-gray-300 flex flex-col rounded font-serif"
     
       >
            {/* Header */}
            <div className="bg-white flex items-center justify-between px-4 py-3 border-b rounded-t-3xl ">
              <div className="flex items-center space-x-3">
                <button
                  className="p-2 rounded-full hover:bg-gray-200"
                  onClick={handleBackClick}
                >
                  <IoIosArrowBack className="text-xl" />
                </button>
                <div className="bg-blue-600 text-white p-2 rounded-full">
                  <FaRobot size={20} />
                </div>
                <span className="font-semibold text-gray-800 text-base sm:text-lg">
                  BL Query Agent
                </span>
              </div>
              <button
                onClick={handleCloseChat}
                className="text-2xl text-gray-400 hover:text-gray-600"
              >
                ×
              </button>
            </div>

            {/* Quick Replies at Top */}
            {prePrompt && (
              <motion.div className="grid grid-cols-2 gap-2 px-4 pt-4 bg-white z-10 sticky top-0">
                {quickReplies.map((reply, i) => (
                  <motion.button
                    key={i}
                    onClick={() => handleQuickReply(reply)}
                    className="border border-blue-500 text-blue-600 rounded-xl px-3 py-2 text-sm hover:bg-blue-50 transition"
                  >
                    {reply}
                  </motion.button>
                ))}
              </motion.div>
            )}

            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 bg-[#f7f7f8]">
              <AnimatePresence>
                {messages.map((msg, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0 }}
                    className={`flex ${
                      msg.type === "user" ? "justify-end" : "justify-start"
                    } mb-2`}
                  >
                    <div
                      className={`p-3 rounded-xl shadow max-w-xs whitespace-pre-wrap text-sm ${
                        msg.type === "user"
                          ? "bg-blue-600 text-white"
                          : "bg-white text-gray-800 border"
                      }`}
                    >
                      {msg.text}
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
              <div ref={chatEndRef}></div>
            </div>

            {/* Input */}
            <form
              onSubmit={handleSubmit}
              className="p-3 border-t flex items-center bg-white relative  pt-1"
            >
              <div className="relative w-full">
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Write a message..."
                  className="w-full border rounded-full px-5 py-4 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                  disabled={loading}
                />
                {filteredHistory.length > 0 && (
                  <div className="absolute bottom-full mb-1 w-full z-10 bg-white border border-gray-200 rounded shadow max-h-40 overflow-y-auto">
                    {filteredHistory.map((item, idx) => (
                      <div
                        key={idx}
                        onClick={() => setInput(item)}
                        className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 cursor-pointer"
                      >
                        {item}
                      </div>
                    ))}
                  </div>
                )}
                 {tracRes && (
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center space-x-1">
                    <button
                      type="button"
                      onClick={stopTyping}
                      className="text-gray-600 hover:text-gray-800 text-xl"
                      title="Stop Generating"
                    >
                      <FaStopCircle />
                    </button>
                  </div>
                )}
              </div>
              <motion.button
                whileTap={{ scale: 0.9 }}
                type="submit"
                className="text-blue-600 text-xl p-2 ml-2"
                disabled={loading}
              >
                <BsSend />
              </motion.button>
            </form>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating Chat Icon */}
    {/* Floating Chat Icon */}
{!isOpen && !showWelcome && (
  <button
    onClick={() => setShowWelcome(true)}
    className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center text-white shadow-lg"
  >
    <FaRobot size={22} />
  </button>
)}

    </>
  );
};

export default ChatBot;
